"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useForgotPassword = void 0;

var _reactQuery = require("react-query");

var _api = require("../api");

var useForgotPassword = function useForgotPassword() {
  return (0, _reactQuery.useMutation)(function (request) {
    return (0, _api.forgotPassword)(request);
  });
};

exports.useForgotPassword = useForgotPassword;